import React from "react";
import { SERVICES } from "@/lib/pnp";
import { Rise, RevealWords } from "./Reveal";
import { motion } from "framer-motion";

export default function Services() {
  return (
    <section
      id="leistungen"
      data-testid="services-section"
      className="relative bg-[#F4F7F5] py-24 md:py-40"
    >
      <div className="px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 md:mb-20">
          <div>
            <div className="font-mono-pp text-[11px] uppercase tracking-[0.24em] text-[#4F6858] mb-6">
              Leistungen · Index
            </div>
            <h2
              className="font-display font-extrabold text-[#082E19] leading-[0.92] tracking-tighter max-w-3xl"
              style={{ fontSize: "clamp(2.25rem, 5.4vw, 4.5rem)" }}
            >
              <RevealWords text="Alles was Ihr Garten braucht — aus einer Hand." />
            </h2>
          </div>
          <div className="font-mono-pp text-[11px] uppercase tracking-[0.24em] text-[#4F6858]">
            08 Leistungen
          </div>
        </div>

        <ul className="border-t border-[#DFEBE4]">
          {SERVICES.map((s, i) => (
            <li key={s.id} className="border-b border-[#DFEBE4]">
              <Rise delay={i * 0.03}>
                <motion.div
                  data-testid="service-item"
                  whileHover={{ backgroundColor: "#FFFFFF" }}
                  transition={{ duration: 0.25 }}
                  className="group grid grid-cols-12 gap-4 py-7 md:py-9 items-center px-2 -mx-2 rounded-sm"
                >
                  <div className="col-span-2 md:col-span-1 font-mono-pp text-[11px] tracking-[0.2em] text-[#4F6858]">
                    /{s.id}
                  </div>
                  <div className="col-span-10 md:col-span-4">
                    <h3
                      className="font-display font-bold text-[#082E19] tracking-tight group-hover:text-[#17C964] transition-colors"
                      style={{ fontSize: "clamp(1.5rem, 2.8vw, 2.25rem)" }}
                    >
                      {s.title}
                    </h3>
                  </div>
                  <div className="col-span-12 md:col-span-6 text-[#4F6858] text-[15px] md:text-base leading-relaxed">
                    {s.desc}
                  </div>
                  <div className="col-span-12 md:col-span-1 flex md:justify-end">
                    <motion.span
                      className="inline-flex h-9 w-9 rounded-full items-center justify-center bg-[#082E19] text-white group-hover:bg-[#17C964] transition-colors"
                      whileHover={{ rotate: 45 }}
                      transition={{ type: "spring", stiffness: 240, damping: 20 }}
                    >
                      +
                    </motion.span>
                  </div>
                </motion.div>
              </Rise>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
